<template>
  <div class="data-list">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入材料名称查找..."></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable(1)">查找</Button>
          </FormItem>
          <FormItem>
            <Button @click="showModel()" type="success" class="f-l">添加</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <Drawer
      :title="title"
      v-model="showModalStatus"
      width="1200"
      :mask-closable="false"
      :styles="styles"
    >
      <Tabs v-model="step">
        <TabPane label="基础信息" name="firstStep">
          <Form :model="goods" :label-width="80" ref="goodsValidate" :rules="goodsValidate">
            <Row>
              <Col span="12">
                <FormItem label="材料标题" label-position="top" prop="title">
                  <Input v-model="goods.name" placeholder="材料标题">></Input>
                </FormItem>
              </Col>
            </Row>

            <Row style="margin-top: 20px;">
              <Col span="8">
                <FormItem label="库存" label-position="top" prop="store">
                  <Input v-model="goods.store" :readonly="isBlockGoods"></Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem label="默认价格" label-position="top" prop="prices">
                  <Input v-model="goods.prices"></Input>
                </FormItem>
              </Col>
            </Row>
            <FormItem label="关键字" label-position="top" prop="keyword">
              <Input v-model="goods.keyword"></Input>
            </FormItem>
            <FormItem label="描述" label-position="top" prop="describe">
              <Input type="textarea" v-model="goods.describe" :rows="3" placeholder="请输入描述" />
            </FormItem>
            <Row>
              <Col span="8">
                <FormItem label="上架时间" prop="start_time">
                  <DatePicker
                    v-model="goods.start_time"
                    format="yyyy-MM-dd HH:mm:ss"
                    placeholder="上架时间"
                    style="width: 200px"
                    @on-change="changeDateOne"
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem label="下架时间" prop="end_time">
                  <DatePicker
                    v-model="goods.end_time"
                    format="yyyy-MM-dd HH:mm:ss"
                    placeholder="下架时间"
                    style="width: 200px"
                    @on-change="changeDateTwo"
                  ></DatePicker>
                </FormItem>
              </Col>
            </Row>
            <FormItem label="缩略图" prop="thumb">
              <upload-thumb
                v-model="goods.thumb"
                ref="uploadthumb"
                :defaultList="thumblist"
                :autoCropWidth="320" :autoCropHeight="320"
                :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:320*320,大小不超过2M'"
              ></upload-thumb>
            </FormItem>
            <FormItem label="相册" prop="album">
              <upload-thumb
                v-model="goods.album"
                ref="uploadthumbTwo"
                :defaultList="thumblistTwo"
                :autoCropWidth="750" :autoCropHeight="400"
                :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:750*400,大小不超过2M'"
              ></upload-thumb>
            </FormItem>
            <FormItem label="内容" prop="content">
              <UEditor v-model="goods.content" ref="editContent"></UEditor>
            </FormItem>
          </Form>
        </TabPane>
        <TabPane label="营销信息" name="secondStep">
          <Form :model="goods" :label-width="80">
            <Row>
              <Col span="6">
                <FormItem label="是否支持7天无理由退货" label-position="top">
                  <RadioGroup v-model="goods.is_seven_return">
                    <Radio label="0">否</Radio>
                    <Radio label="1">是</Radio>
                  </RadioGroup>
                </FormItem>
              </Col>
              <Col span="6">
                <FormItem label="是否自营" label-position="top">
                  <RadioGroup v-model="goods.is_zixing">
                    <Radio label="0">否</Radio>
                    <Radio label="1">是</Radio>
                  </RadioGroup>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </TabPane>
      </Tabs>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="showModalStatus = false;step='firstStep'">取消</Button>
        <Button type="primary" @click="creategoods('goodsValidate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import UEditor from "../common/ueditor";
import uploadthumbTwo from "../common/thumb";

export default {
  name: "data-list",
  data() {
    const validateThumb = (rule, value, callback) => {
      if (this.$refs["uploadthumb"].uploadList.length == 0) {
        callback(new Error("请上传缩略图"));
      } else {
        callback();
      }
    };
    const validateThumbTwo = (rule, value, callback) => {
      if (this.$refs["uploadthumbTwo"].uploadList.length == 0) {
        callback(new Error("请上传相冊"));
      } else {
        callback();
      }
    };
    const validateContent = (rule, value, callback) => {
      if (this.goods.content == "") {
        callback(new Error("内容必须填写"));
      } else {
        callback();
      }
    };
    const validatePirces = (rule, value, callback) => {
      if (
        this.goods.prices == "" ||
        this.goods.prices == null ||
        this.goods.prices == undefined
      ) {
        callback(new Error("价格必须填写"));
      } else {
        callback();
      }
    };
    const validateStore = (rule, value, callback) => {
      if (
        this.goods.store == "" ||
        this.goods.store == null ||
        this.goods.store == undefined
      ) {
        callback(new Error("库存必须填写"));
      } else {
        callback();
      }
    };
    return {
      step: "firstStep",
      fx: "0",
      editSpecLoading: true, // 修改规格loading
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      isBlockGoods: false,
      tempId: "",

      goodsAttrList: [],
      goods: {
        name: "",
        keyword: "",
        describe: "",
        content: "",
        thumb: "",
        album: "",
        is_zixing: "0",
        is_seven_return: "0"
      },
      isable: true,
      editor: {
        ifno: ""
      },
      isClear: false,
      loading: true,
      dataloading: true,
      thumblist: [],
      thumblistTwo: [],
      datePic: [],
      statusList: [
        { id: 1, name: "正常" },
        { id: 0, name: "下架" }
      ],

      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: "",
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "标题",
          key: "name",
          minWidth: 200
        },
        {
          title: "库存",
          key: "store",
          minWidth: 80
        },
        {
          title: "销量",
          key: "sale",
          minWidth: 80
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      goodsValidate: {
        name: [{ required: true, message: "名称必须填写", trigger: "blur" }],
        keyword: [
          { required: true, message: "关键词必须填写", trigger: "blur" }
        ],
        describe: [
          { required: true, message: "描述必须填写", trigger: "blur" }
        ],
        content: [
          { required: true, validator: validateContent, trigger: "change" }
        ],
        thumb: [
          { required: true, validator: validateThumb, trigger: "change" }
        ],
        album: [
          { required: true, validator: validateThumbTwo, trigger: "change" }
        ],
        prices: [
          { required: true, validator: validatePirces, trigger: "blur" }
        ],
        store: [{ required: true, validator: validateStore, trigger: "blur" }],
        start_time: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.goods.start_time == "") {
                callback(new Error("上架时间必须填写"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        end_time: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.goods.end_time == "") {
                callback(new Error("下架时间必须填写"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ]
      },
      id: 0
    };
  },
  created: function() {
    this.getTableList();
  },
  components: {
    UploadThumb,
    UEditor,
    uploadthumbTwo
  },

  methods: {
    getTableList: function() {
      this.$api.data
        .list({
          page: this.pages.page,
          size: this.pages.size
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
            // 同步筛选条件
            this.renderTable();
          }
        });
      return;
    },
    changeDateTwo(val) {
      this.goods.end_time = val;
    },
    changeDateOne(val) {
      this.goods.start_time = val;
    },
    // 展开添加
    showModel() {
      this.title = "添加材料";
      this.isBlockGoods = false;
      this.goods = {
        name: "",
        keyword: "",
        describe: "",
        content: "",
        thumb: "",
        album: "",
        is_zixing: "0",
        is_seven_return: "0"
      };
      this.isable = true;
      this.thumblist = new Array();
      this.thumblistTwo = new Array();
      this.selectCateId = "";
      this.selectCate = [];

      this.$refs["goodsValidate"].resetFields();
      this.$refs["editContent"].message = "";
      var d1 = new Date();
      var d2 = new Date();
      d2.setFullYear(d1.getFullYear() + 1);
      this.goods.start_time = this.formatDate(d1, "yyyy-MM-dd hh:mm:ss");
      this.goods.end_time = this.formatDate(d2, "yyyy-MM-dd hh:mm:ss");
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail(id) {
      this.title = "编辑材料";
      this.thumblist = new Array();
      this.thumblistTwo = new Array();
      this.$refs["goodsValidate"].resetFields();
      this.showModalStatus = true;
      this.$api.data.detail({ id: id }).then(res => {
        this.goods = res.result;
        this.goods.is_zixing = res.result.is_zixing.toString();
        this.goods.is_seven_return = res.result.is_seven_return.toString();
        this.$refs["editContent"].message = res.result.content;
        //处理thumb
        if (this.goods.thumb != null && this.goods.thumb != "") {
          this.thumblist.push({
            name: this.goods.thumb,
            url: this.goods.thumb,
            status: "finished"
          });
        }
        if (this.goods.album != null && this.goods.album.length > 0) {
          this.goods.attrShow = this.goods.album.split(",");
          for (var s in this.goods.attrShow) {
            this.thumblistTwo.push({
              name: this.goods.attrShow[s],
              url: this.goods.attrShow[s],
              status: "finished"
            });
          }
        }
        this.selectCate = selectCate;
      });
    },
    // 添加
    creategoods(name) {
      this.goods.content = this.$refs["editContent"].message;
      this.$refs[name].validate(valid => {
        // console.log(valid);
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.goods.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          } else {
            this.goods.thumb = null;
          }
          // return
          //相册
          if (this.$refs["uploadthumbTwo"].uploadList.length > 0) {
            var finalAttrs = "";
            var tList = this.$refs["uploadthumbTwo"].uploadList;
            for (var s in tList) {
              finalAttrs = finalAttrs + tList[s].url + ",";
            }
            if (finalAttrs != "") {
              this.goods.album = finalAttrs.substring(0, finalAttrs.length - 1);
            }
          }
          // console.log(this.goods.start_time);
          this.goods.start_time = this.formatDate(
            this.goods.start_time,
            "yyyy-MM-dd hh:mm:ss"
          );
          this.goods.end_time = this.formatDate(
            this.goods.end_time,
            "yyyy-MM-dd hh:mm:ss"
          );
          // console.log(this.goods);

          if (
            this.goods.id == null ||
            this.goods.id == 0 ||
            this.goods.id == undefined
          ) {
            //新建材料
            this.$api.data.create(this.goods).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.showModalStatus = false;
                this.step = "firstStep";
              }
              this.goods.id = null;
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
            });
          } else {
            //编辑材料
            this.$api.data.edit(this.goods).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.showModalStatus = false;
                this.step = "firstStep";
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 删除
    remove: function(id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.data.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList(1);
            }
          });
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable();
    },
    // 筛选
    renderTable: function(name) {
      if (name == 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.data.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    formatDate(tt, fmt) {
      if (null == tt || "" == tt) return "";
      var date = new Date(tt);
      let o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        S: date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
